import PropTypes from "prop-types";
import classNames from "classnames";
import { asIcon } from "../utils/library";

const Follow = ({ className, height = "32px", width = "32px" }) => {
    const classes = classNames("followIcon", className);
    return (
        <svg
            className={classes}
            width={width}
            height={height}
            viewBox="0 0 32 32"
        >
            <g fillRule="evenodd">
                <path d="m16 0c8.8366 0 16 7.1634 16 16s-7.1634 16-16 16-16-7.1634-16-16 7.1634-16 16-16zm1.1176 8.1765h-2.2353v6.7059h-6.7059v2.2353h6.7059v6.7059h2.2353v-6.7059h6.7059v-2.2353h-6.7059v-6.7059z" />
            </g>
        </svg>
    );
};

Follow.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

const IconFollow = asIcon(Follow);
export { IconFollow, Follow };
